import React from 'react';
import { RadioButton } from '@everlywell/leaves';

// local imports
import * as S from './styles';
import { ExposureLevels } from '../';

export type ExposureLevelsProps = {
  handleExposureClick: Function;
  exposureLevel: string;
};

const ExposureQuestions = ({
  handleExposureClick,
  exposureLevel,
}: ExposureLevelsProps) => {
  return (
    <>
      <S.QuestionCount>Question 2 of 2</S.QuestionCount>
      <S.Question>Please describe your exposure to Coronavirus.</S.Question>
      <S.Fieldset>
        <S.Legend>Please describe your exposure to Coronavirus.</S.Legend>
        <S.RadioOption
          onClick={() => handleExposureClick(ExposureLevels.NoExposure)}
        >
          <S.RadioOptionHeading>
            <S.OptionTitle>No exposure</S.OptionTitle>
            {/* @ts-ignore */}
            <RadioButton
              id={ExposureLevels.NoExposure}
              name={ExposureLevels.NoExposure}
              label="."
              checked={exposureLevel === ExposureLevels.NoExposure}
              onChange={() => handleExposureClick(ExposureLevels.NoExposure)}
            />
          </S.RadioOptionHeading>
          <S.RadioOptionContent>
            <S.Text>I have not been exposed to COVID-19.</S.Text>
          </S.RadioOptionContent>
        </S.RadioOption>
        <S.RadioOption
          onClick={() => handleExposureClick(ExposureLevels.PotentialExposure)}
        >
          <S.RadioOptionHeading>
            <S.OptionTitle>Potential exposure</S.OptionTitle>
            {/* @ts-ignore */}
            <RadioButton
              id={ExposureLevels.PotentialExposure}
              name={ExposureLevels.PotentialExposure}
              label="."
              checked={exposureLevel === ExposureLevels.PotentialExposure}
              onChange={() =>
                handleExposureClick(ExposureLevels.PotentialExposure)
              }
            />
          </S.RadioOptionHeading>
          <S.RadioOptionContent>
            <S.Text>
              I live or work in a place where people reside, meet or gather in
              close proximity (office buildings, schools, healthcare facilities,
              etc).
            </S.Text>
          </S.RadioOptionContent>
        </S.RadioOption>
        <S.RadioOption
          onClick={() => handleExposureClick(ExposureLevels.SuspectedExposure)}
        >
          <S.RadioOptionHeading>
            <S.OptionTitle>Suspected Exposure</S.OptionTitle>
            {/* @ts-ignore */}
            <RadioButton
              id={ExposureLevels.SuspectedExposure}
              name={ExposureLevels.SuspectedExposure}
              label="."
              checked={exposureLevel === ExposureLevels.SuspectedExposure}
              onChange={() =>
                handleExposureClick(ExposureLevels.SuspectedExposure)
              }
            />
          </S.RadioOptionHeading>
          <S.RadioOptionContent>
            <S.Text>
              I have been in close proximity (within 6 ft) to someone who is
              sick but not diagnosed with COVID-19.
            </S.Text>
          </S.RadioOptionContent>
        </S.RadioOption>
        <S.RadioOption
          onClick={() => handleExposureClick(ExposureLevels.KnownExposure)}
        >
          <S.RadioOptionHeading>
            <S.OptionTitle>Known Exposure</S.OptionTitle>
            {/* @ts-ignore */}
            <RadioButton
              id={ExposureLevels.KnownExposure}
              name={ExposureLevels.KnownExposure}
              label="."
              checked={exposureLevel === ExposureLevels.KnownExposure}
              onChange={() => handleExposureClick(ExposureLevels.KnownExposure)}
            />
          </S.RadioOptionHeading>
          <S.RadioOptionContent>
            <S.Text>
              I have been in close proximity (within 6 ft) to someone who has
              been diagnosed or presumed to have COVID-19.
            </S.Text>
          </S.RadioOptionContent>
        </S.RadioOption>
      </S.Fieldset>
    </>
  );
};

export default ExposureQuestions;
